export default __webpack_public_path__ + "static/media/1848.f83603b4.png";